import React, { useState, useCallback, useMemo } from 'react';
import { Stack } from 'react-bootstrap';
import { SalaryChangeComponentProps } from './types';
import { SalaryChangeStepOne } from './SalaryChangeStepOne';
import { SalaryChangeStepTwo } from './SalaryChangeStepTwo';

export const SalaryChangeStepsWrapper: React.FC<SalaryChangeComponentProps> = ({
  selectedEmployeeId,
  currentSalary = 0,
  currency = '$',
  onChange,
  value,
  positionChangeData,
}) => {
  const [currentSubStep, setCurrentSubStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState<'quick' | 'new' | null>(
    value?.isQuickUpdate === true
      ? 'quick'
      : value?.isQuickUpdate === false
      ? 'new'
      : null,
  );

  const updateAmountOnly = useMemo(() => {
    return selectedOption === 'quick';
  }, [selectedOption]);

  const handleOptionSelect = useCallback((option: 'quick' | 'new') => {
    setSelectedOption(option);
    setCurrentSubStep(1);
  }, []);

  const renderCurrentStep = () => {
    if (currentSubStep === 0) {
      return <SalaryChangeStepOne onOptionSelect={handleOptionSelect} />;
    } else {
      return (
        <SalaryChangeStepTwo
          selectedEmployeeId={selectedEmployeeId}
          currentSalary={currentSalary}
          currency={currency}
          onChange={onChange}
          value={value}
          updateAmountOnly={updateAmountOnly}
          positionChangeData={positionChangeData}
        />
      );
    }
  };

  return (
    <div className="salary-change-steps-wrapper">
      <Stack gap={3}>{renderCurrentStep()}</Stack>
    </div>
  );
};
